import { createAction } from '@reduxjs/toolkit';
import { Chat, Frame, Scene, Subscription, User, Wallet } from 'dragonmouse-shared/interfaces';
import { OptimisticWrite } from './reducers';

//------------------------------------------------------------------------------------------------
// scenes
//------------------------------------------------------------------------------------------------
export const updateScenes = createAction<Scene[]>('GET_SCENES');
export const optimisticallyUpdateScenes = createAction<OptimisticWrite<Scene>[]>(
	'OPTIMISTICALLY_UPDATE_SCENES'
);
export const resolveOptimisticallyUpdatedScenes = createAction<string[]>(
	'RESOLVE_OPTIMISTICALLY_UPDATED_SCENES'
);
export const setSceneLoadError = createAction<string | null>('SET_SCENE_LOAD_ERROR');

// guest
export const updateGuestScenes = createAction<Scene[]>('UPDATE_GUEST_SCENES');

//------------------------------------------------------------------------------------------------
// frames
//------------------------------------------------------------------------------------------------
export const updateFrames = createAction<Frame[]>('UPDATE_FRAMES');
export const optimisticallyUpdateFrames = createAction<OptimisticWrite<Frame>[]>(
	'OPTIMISTICALLY_UPDATE_FRAMES'
);
export const resolveOptimisticallyUpdatedFrames = createAction<string[]>(
	'RESOLVE_OPTIMISTICALLY_UPDATED_FRAMES'
);
export const refreshFramePermissions = createAction('REFRESH_FRAME_PERMISSIONS');
// guest
export const updateGuestFrames = createAction<Frame[]>('UPDATE_GUEST_FRAMES');

//------------------------------------------------------------------------------------------------
// chats
//------------------------------------------------------------------------------------------------
export const updateChats = createAction<Chat[]>('UPDATE_CHATS');
export const optimisticallyUpdateChats = createAction<OptimisticWrite<Chat>[]>(
	'OPTIMISTICALLY_UPDATE_CHATS'
);
export const resolveOptimisticallyUpdatedChats = createAction<string[]>(
	'RESOLVE_OPTIMISTICALLY_UPDATED_CHATS'
);

//------------------------------------------------------------------------------------------------
// user
//------------------------------------------------------------------------------------------------
export const updateUser = createAction<User | null>('UPDATE_USER');
export const optimisticallyUpdateUser = createAction<OptimisticWrite<User>[]>(
	'OPTIMISTICALLY_UPDATE_USER'
);
export const resolveOptimisticallyUpdatedUser = createAction<string[]>(
	'RESOLVE_OPTIMISTICALLY_UPDATED_USER'
);

//------------------------------------------------------------------------------------------------
// subscription
//------------------------------------------------------------------------------------------------
export const updateSubscription = createAction<Subscription | null>('UPDATE_SUBSCRIPTION');

//------------------------------------------------------------------------------------------------
// wallet
//------------------------------------------------------------------------------------------------
export const updateWallet = createAction<Wallet | null>('UPDATE_WALLET');

//------------------------------------------------------------------------------------------------
// tracked users
//------------------------------------------------------------------------------------------------
export const updateTrackedUsers = createAction<User[]>('UPDATE_TRACKED_USERS');

//------------------------------------------------------------------------------------------------
// loading state (tracks things that are loaded by electric)
//------------------------------------------------------------------------------------------------
export type LoadingStateType = 'never-loaded' | 'loading' | 'loaded';

export interface LoadingState {
	user: LoadingStateType;
	sceneIds: LoadingStateType;
	scenes: LoadingStateType;
	activeScene: {
		frames: LoadingStateType;
		chats: LoadingStateType;
	};
	guest: {
		scenes: LoadingStateType;
		frames: LoadingStateType;
	};
}

export const setLoadingState = createAction<{ resource: string; state: LoadingStateType }>(
	'SET_LOADING_STATE'
);
